export default __webpack_public_path__ + "static/media/NT.27bda677.jpeg";